module.exports = __webpack_public_path__ + "static/media/esg_schema_cz.32117eae.svg";